"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = exports["default"] = exports.SocialLinks = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _makeStyles = _interopRequireDefault(require("../styles/makeStyles"));

var _TrackingLink = _interopRequireDefault(require("../TrackingLink"));

var _Typography = _interopRequireDefault(require("../Typography"));

var _Spacing = _interopRequireDefault(require("../Spacing"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/** EarnUp Social Media Links */
var SOCIAL_FACEBOOK_ICON = function SOCIAL_FACEBOOK_ICON(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("title", null, "Facebook Footer"), /*#__PURE__*/_react["default"].createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react["default"].createElement("circle", {
    stroke: "#00AB61",
    fill: "#FFF",
    cx: "20",
    cy: "20",
    r: "19.5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M21.093 27v-6.3h2.04l.334-2.8h-2.374v-1.364c0-.72.02-1.436 1.095-1.436h1.088v-2.002c0-.03-.935-.098-1.88-.098-1.976 0-3.213 1.16-3.213 3.29v1.61H16v2.8h2.183V27h2.91z",
    fill: "#00AB61"
  })));
};

SOCIAL_FACEBOOK_ICON.defaultProps = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  xmlns: "http://www.w3.org/2000/svg"
};

var SOCIAL_TWITTER_ICON = function SOCIAL_TWITTER_ICON(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("title", null, "Twitter Footer"), /*#__PURE__*/_react["default"].createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react["default"].createElement("circle", {
    stroke: "#00AB61",
    fill: "#FFF",
    cx: "20",
    cy: "20",
    r: "19.5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M30 13.894a8.294 8.294 0 0 1-2.357.636 4.058 4.058 0 0 0 1.805-2.235 8.299 8.299 0 0 1-2.606.98A4.127 4.127 0 0 0 23.847 12c-2.65 0-4.596 2.433-3.998 4.959a11.71 11.71 0 0 1-8.456-4.22 4.007 4.007 0 0 0 1.269 5.393 4.135 4.135 0 0 1-1.858-.505c-.045 1.87 1.318 3.622 3.291 4.011-.577.154-1.21.19-1.853.07.521 1.604 2.036 2.771 3.833 2.804A8.344 8.344 0 0 1 10 26.185 11.75 11.75 0 0 0 16.29 28c7.618 0 11.923-6.334 11.663-12.015A8.283 8.283 0 0 0 30 13.895z",
    fill: "#00AB61"
  })));
};

SOCIAL_TWITTER_ICON.defaultProps = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  xmlns: "http://www.w3.org/2000/svg"
};

var SOCIAL_LINKEDIN_ICON = function SOCIAL_LINKEDIN_ICON(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("title", null, "LinkedIn Footer"), /*#__PURE__*/_react["default"].createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react["default"].createElement("circle", {
    stroke: "#00AB61",
    fill: "#FFF",
    cx: "20",
    cy: "20",
    r: "19.5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16 16v9h-3v-9h3zm4.797 1.445C21.977 15.328 27 15.172 27 19.472V25h-2.808v-4.583c0-2.757-3.394-2.549-3.394 0V25H18v-8.73h2.797zM14.5 12a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3z",
    fill: "#00AB61"
  })));
};

SOCIAL_LINKEDIN_ICON.defaultProps = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  xmlns: "http://www.w3.org/2000/svg"
};
var SOCIAL_FACEBOOK = 'https://www.facebook.com/earnupnow/';
var SOCIAL_TWITTER = 'https://twitter.com/earnup';
var SOCIAL_LINKEDIN = 'https://www.linkedin.com/company/earnup';

var styles = function styles(theme) {
  var _ref;

  return _ref = {
    socialLinksTitle: {
      fontWeight: 800,
      fontSize: theme.typography.subtitle2.fontSize,
      paddingBottom: theme.spacing(1)
    },
    socialLinks: {
      display: 'flex',
      justifyContent: 'center',
      width: '60%',
      marginTop: '10px'
    },
    linkFacebook: {
      flex: '25%'
    },
    linkTwitter: {
      flex: '25%'
    },
    linkLinkedIn: {
      flex: '25%'
    },
    linkAngelList: {
      flex: '25%'
    },
    socialIcon: {
      width: 40,
      height: 40
    },
    mailingAddress: {
      textAlign: 'left'
    }
  }, (0, _defineProperty2["default"])(_ref, theme.breakpoints.down('md'), {
    socialLinks: {
      width: '80%'
    }
  }), (0, _defineProperty2["default"])(_ref, theme.breakpoints.down('sm'), {
    socialLinksTitle: {
      textAlign: 'center'
    },
    socialLinks: {
      width: '100%',
      textAlign: 'center'
    },
    mailingAddress: {
      textAlign: 'center'
    }
  }), _ref;
};

exports.styles = styles;
var useStyles = (0, _makeStyles["default"])(styles);

var SocialLinks = function SocialLinks(_ref2) {
  var _ref2$Link = _ref2.Link,
      Link = _ref2$Link === void 0 ? _TrackingLink["default"] : _ref2$Link;
  var classes = useStyles();
  return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement(_Spacing["default"], {
    className: classes.links,
    marginBottom: 2
  }, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    className: classes.socialLinksTitle
  }, "CONTACT US"), /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.socialLinks
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.linkFacebook
  }, /*#__PURE__*/_react["default"].createElement(Link, {
    variant: "text",
    className: classes.link,
    to: SOCIAL_FACEBOOK,
    dataQa: "footer-social-facebook"
  }, /*#__PURE__*/_react["default"].createElement(SOCIAL_FACEBOOK_ICON, null))), /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.linkTwitter
  }, /*#__PURE__*/_react["default"].createElement(Link, {
    variant: "text",
    className: classes.link,
    to: SOCIAL_TWITTER,
    dataQa: "footer-social-twitter"
  }, /*#__PURE__*/_react["default"].createElement(SOCIAL_TWITTER_ICON, null))), /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.linkLinkedIn
  }, /*#__PURE__*/_react["default"].createElement(Link, {
    variant: "text",
    className: classes.link,
    to: SOCIAL_LINKEDIN,
    dataQa: "footer-social-linkedin"
  }, /*#__PURE__*/_react["default"].createElement(SOCIAL_LINKEDIN_ICON, null))))), /*#__PURE__*/_react["default"].createElement(_Spacing["default"], {
    marginBottom: 4
  }, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    className: classes.mailingAddress,
    variant: "body1"
  }, "2370 Market St Suite 203,", /*#__PURE__*/_react["default"].createElement("br", null), " San Francisco, CA 94114")));
};

exports.SocialLinks = SocialLinks;
var _default = SocialLinks;
exports["default"] = _default;